import { KeyConstructor } from './keyConstructor.js'

const pingSessionKey = 'pingSession'

export const getPingSessionKey = KeyConstructor<never, never>(pingSessionKey)
